var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardIconX(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7181 12.5846L16.5723 16.4388M16.5723 12.5846L12.7181 16.4388M16.9577 7.95964H1.54102M16.9577 9.5013V6.57214C16.9577 5.70872 16.9577 5.27702 16.7897 4.94723C16.6418 4.65715 16.406 4.42131 16.1159 4.2735C15.7861 4.10547 15.3544 4.10547 14.491 4.10547H4.00768C3.14427 4.10547 2.71256 4.10547 2.38278 4.2735C2.0927 4.42131 1.85685 4.65715 1.70905 4.94723C1.54102 5.27701 1.54102 5.70872 1.54102 6.57214V12.4305C1.54102 13.2939 1.54102 13.7256 1.70905 14.0554C1.85685 14.3455 2.0927 14.5813 2.38278 14.7291C2.71256 14.8971 3.14427 14.8971 4.00768 14.8971H9.24935",
    stroke: "#ED4863",
    strokeWidth: 1.54167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIconX);
export default __webpack_public_path__ + "static/media/card-icon-x.c372d6d6a0ef8cf14f41ff6dc80a573b.svg";
export { ForwardRef as ReactComponent };